import React from 'react';
import {
  Box, ToggleButton, ToggleButtonGroup,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  fillingStatusFromValue,
  formattedFillingStatusBasedOnRead,
} from 'components/utils/fillingType';
import useFillingChange from './hooks/useFillingChange';

/**
 * Without the operation form (weighed containers), the change is applied directly.
 * @param {{ inventoryData: any, itemData: any, setInventoryData: any, formik?: any }} props
 */
export default function ChangeFillingToggle({
  inventoryData, itemData, setInventoryData, formik,
}) {
  const { t } = useTranslation();
  const {
    requestFillingChange,
    currentRawStatus,
    loading,
    dialog,
  } = useFillingChange({
    inventoryData, itemData, setInventoryData, formik,
  });
  const currentStatus = fillingStatusFromValue(currentRawStatus);

  const handleChange = (event, newStatus) => {
    if (!newStatus || newStatus === currentStatus) {
      return;
    }

    const hasCurrentRawStatus = currentRawStatus !== undefined
      && currentRawStatus !== null
      && currentRawStatus !== '';
    const formattedStatus = hasCurrentRawStatus
      ? formattedFillingStatusBasedOnRead(currentRawStatus, newStatus)
      : newStatus;

    requestFillingChange(formattedStatus);
  };

  return (
    <Box sx={{
      display: 'flex', justifyContent: 'center',
    }}
    >
      <ToggleButtonGroup
        exclusive
        value={currentStatus}
        onChange={handleChange}
        disabled={loading}
        size="small"
        sx={{
          width: 'fit-content',
          backgroundColor: 'secondary.main',
          borderRadius: 1,
          p: 0.25,
          '& .MuiToggleButton-root': {
            border: 0,
            borderRadius: 0.75,
            color: 'secondary.contrastText',
            fontSize: '0.85rem',
            fontWeight: 'bold',
            lineHeight: 1,
            minWidth: 92,
            px: 1.5,
            py: 0.9,
            textTransform: 'none',
            '&:not(:first-of-type)': {
              ml: 0.25,
            },
            '&.Mui-selected': {
              backgroundColor: 'common.white',
              color: 'secondary.main',
              boxShadow: 1,
            },
            '&.Mui-selected:hover': {
              backgroundColor: 'common.white',
            },
          },
        }}
      >
        {['full', 'draining', 'empty'].map((status) => (
          <ToggleButton key={status} value={status}>
            {t(`inventory_item.filling.${status}`)}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {dialog}
    </Box>
  );
}
